export const transactionFee = 2
